// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-header[data-v-e2af4870] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 10;\n  padding: 14px 20px;\n}\n.left[data-v-e2af4870] {\n  cursor: pointer;\n}\n.left .logo[data-v-e2af4870] {\n  width: 32px;\n  height: 32px;\n  -o-object-fit: contain;\n     object-fit: contain;\n}\n.left .home_title[data-v-e2af4870] {\n  width: 128px;\n  height: 28px;\n  margin-left: 4px;\n  -o-object-fit: contain;\n     object-fit: contain;\n}", ""]);
// Exports
module.exports = exports;
